import { Texture, Vector4 } from "three";

function createDiskTexture({ size }) {
  const side = size * 2;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = side;
  canvas.height = side;

  const textureCoordsMap = [new Vector4(0, 0, 1, 1)];
  ctx.beginPath();
  ctx.lineWidth = 0;
  ctx.arc(size, size, size - 2, 0, 2 * Math.PI);
  ctx.fill();

  const texture = new Texture(canvas);
  texture.flipY = false;
  texture.needsUpdate = true;

  canvas.remove();

  return { texture, textureCoordsMap };
}

export default createDiskTexture;
